var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54858 16.4802C12.9561 16.4802 16.5934 12.8429 16.5934 8.44335C16.5934 4.04466 12.9482 0.406494 8.54062 0.406494C4.14192 0.406494 0.511719 4.04466 0.511719 8.44335C0.511719 12.8429 4.14988 16.4802 8.54858 16.4802ZM11.6889 8.90144L7.03282 11.6305C6.65256 11.856 6.2095 11.6615 6.2095 11.2732V5.63027C6.2095 5.23321 6.67555 5.05546 7.03282 5.26504L11.6889 8.00826C11.766 8.05454 11.8298 8.12 11.8741 8.19826C11.9184 8.27652 11.9417 8.36492 11.9417 8.45485C11.9417 8.54478 11.9184 8.63317 11.8741 8.71144C11.8298 8.7897 11.766 8.85515 11.6889 8.90144Z",
    fill: "#733158"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.cb3859b10794dd419ebc227019d91b2e.svg";
export { ForwardRef as ReactComponent };